var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLinkedinLogo = function SvgLinkedinLogo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23.969,
    height: 23.969,
    viewBox: "0 0 23.969 23.969"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#fff;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "aa",
    d: "M21.572,0H2.4A2.4,2.4,0,0,0,0,2.4V21.572a2.4,2.4,0,0,0,2.4,2.4H21.572a2.4,2.4,0,0,0,2.4-2.4V2.4A2.4,2.4,0,0,0,21.572,0ZM7.191,20.373H3.6V9.587h3.6ZM5.393,7.55A2.157,2.157,0,1,1,7.55,5.393,2.148,2.148,0,0,1,5.393,7.55Zm14.98,12.823h-3.6V14.022a1.8,1.8,0,0,0-3.6,0v6.352h-3.6V9.587h3.6v1.438a3.871,3.871,0,0,1,3-1.678,4.246,4.246,0,0,1,4.195,4.195Z"
  })));
};
export default SvgLinkedinLogo;